"use client";

import { type FieldAttributes, useField, useFormikContext } from "formik";
import { forwardRef } from "react";

import { USER_INTERACTION_DATA_ATTRIBUTE } from "@shared/constants";

import Field from "@ui/js/components/form/field";

interface Props {
  hasAutoComplete?: boolean;
  [USER_INTERACTION_DATA_ATTRIBUTE]?: string;
}

const LeadFormField = forwardRef<HTMLDivElement, FieldAttributes<any> & Props>(
  (props, ref) => {
    const [_, meta] = useField(props);
    const { status } = useFormikContext();
    const {
      hasAutoComplete = false,
      validate,
      name,
      type,
      value,
      innerRef,
      as,
      component,
      render,
      children,
      ...rest
    } = props;

    const error =
      meta.error ||
      (status === "error" &&
        "An error occurred while processing your request. Please try again.");

    const state = status || (error ? "error" : undefined);

    return (
      <Field
        ref={ref}
        {...rest}
        message={error}
        state={state}
        hasAutoComplete={hasAutoComplete}
      >
        {children}
      </Field>
    );
  },
);

LeadFormField.displayName = "LeadFormField";

export default LeadFormField;
